import { render, staticRenderFns } from "./navmenu.vue?vue&type=template&id=36fe183d"
import script from "./navmenu.ts?vue&type=script&lang=js&external"
export * from "./navmenu.ts?vue&type=script&lang=js&external"
import style0 from "./navmenu.vue?vue&type=style&index=0&id=36fe183d&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports